export const products = [
  {
    id: 1,
    name: "Golden Retriever Statue",
    category: "Dog",
    price: 89.99,
    rating: 4.8,
    reviews: 124,
    description: "A beautifully crafted golden retriever statue made from premium resin. Perfect for home decor and dog lovers. Hand-painted with intricate details that capture the warm, friendly nature of this beloved breed.",
    images: [
      "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&q=80",
      "https://images.unsplash.com/photo-1552053831-71594a27632d?w=600&q=80",
    ],
    featured: true,
  },
  {
    id: 2,
    name: "Majestic German Shepherd",
    category: "Dog",
    price: 119.99,
    rating: 4.9,
    reviews: 87,
    description: "An imposing German Shepherd statue capturing the noble stance of this intelligent breed. Crafted with attention to detail, perfect as a statement piece for any room.",
    images: [
      "https://images.unsplash.com/photo-1589941013453-ec89f33b5e95?w=600&q=80",
      "https://images.unsplash.com/photo-1615751072497-5f5169febe17?w=600&q=80",
    ],
    featured: true,
  },
  {
    id: 3,
    name: "Persian Cat Sculpture",
    category: "Cat",
    price: 74.99,
    rating: 4.7,
    reviews: 156,
    description: "An elegant Persian cat sculpture exuding regal sophistication. This premium piece features the distinctive round face and luxurious coat of the Persian breed, rendered in exquisite detail.",
    images: [
      "https://images.unsplash.com/photo-1574144611937-0df059b5ef3e?w=600&q=80",
      "https://images.unsplash.com/photo-1592194996308-7b43878e84a6?w=600&q=80",
    ],
    featured: true,
  },
  {
    id: 4,
    name: "Siamese Cat Figurine",
    category: "Cat",
    price: 64.99,
    rating: 4.6,
    reviews: 93,
    description: "A graceful Siamese cat figurine with striking color contrast. The sleek, elegant form of this beloved breed is captured in every curve and detail of this premium sculpture.",
    images: [
      "https://images.unsplash.com/photo-1596854407944-bf87f6fdd49e?w=600&q=80",
      "https://images.unsplash.com/photo-1513360371669-4adf3dd7dff8?w=600&q=80",
    ],
    featured: false,
  },
  {
    id: 5,
    name: "Majestic Lion Statue",
    category: "Wild Animals",
    price: 149.99,
    rating: 4.9,
    reviews: 201,
    description: "A powerful lion statue that commands presence in any space. The King of the Jungle is depicted in all his glory with a flowing mane and proud stance. A true centerpiece for any collection.",
    images: [
      "https://images.unsplash.com/photo-1546182990-dffeafbe841d?w=600&q=80",
      "https://images.unsplash.com/photo-1559715745-e1b33a271c8f?w=600&q=80",
    ],
    featured: true,
  },
  {
    id: 6,
    name: "Elephant Family Sculpture",
    category: "Wild Animals",
    price: 189.99,
    rating: 4.8,
    reviews: 167,
    description: "A heartwarming elephant family sculpture depicting a mother and calf. Symbolizing strength, wisdom, and family bonds, this piece brings good fortune and positive energy to any home.",
    images: [
      "https://images.unsplash.com/photo-1564760055775-d63b17a55c44?w=600&q=80",
      "https://images.unsplash.com/photo-1474511320723-9a56873867b5?w=600&q=80",
    ],
    featured: true,
  },
  {
    id: 7,
    name: "Husky Dog Statue",
    category: "Dog",
    price: 99.99,
    rating: 4.7,
    reviews: 78,
    description: "A stunning Siberian Husky statue with piercing blue eyes captured in lifelike detail. The athletic build and wolf-like features of this breed are beautifully rendered in premium resin.",
    images: [
      "https://images.unsplash.com/photo-1601979031925-424e53b6caaa?w=600&q=80",
      "https://images.unsplash.com/photo-1605568427561-40dd23c2acea?w=600&q=80",
    ],
    featured: false,
  },
  {
    id: 8,
    name: "British Shorthair Cat",
    category: "Cat",
    price: 84.99,
    rating: 4.5,
    reviews: 112,
    description: "A charming British Shorthair cat sculpture with its characteristic round face and dense coat. This adorable piece captures the calm, gentle nature of one of the world's most popular cat breeds.",
    images: [
      "https://images.unsplash.com/photo-1573865526739-10659fec78a5?w=600&q=80",
      "https://images.unsplash.com/photo-1478098711619-5ab0b478d6e6?w=600&q=80",
    ],
    featured: false,
  },
  {
    id: 9,
    name: "Wild Wolf Howling",
    category: "Wild Animals",
    price: 134.99,
    rating: 4.8,
    reviews: 89,
    description: "A dramatic wolf howling at the moon sculpture. Capturing the raw, untamed spirit of the wild, this piece features exceptional craftsmanship with every detail of the wolf's powerful form.",
    images: [
      "https://images.unsplash.com/photo-1546190255-431e2ed8cfdc?w=600&q=80",
      "https://images.unsplash.com/photo-1474511320723-9a56873867b5?w=600&q=80",
    ],
    featured: false,
  },
  {
    id: 10,
    name: "Poodle Elegance Statue",
    category: "Dog",
    price: 94.99,
    rating: 4.6,
    reviews: 65,
    description: "An elegant poodle statue showcasing the breed's signature curly coat and dignified posture. Perfect for those who appreciate fine craftsmanship and the timeless elegance of this classic breed.",
    images: [
      "https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?w=600&q=80",
      "https://images.unsplash.com/photo-1524594152303-9fd13543fe6e?w=600&q=80",
    ],
    featured: false,
  },
  {
    id: 11,
    name: "Majestic Eagle Sculpture",
    category: "Wild Animals",
    price: 159.99,
    rating: 4.9,
    reviews: 143,
    description: "A breathtaking bald eagle sculpture with wings spread wide. Symbolizing freedom, strength, and vision, this masterpiece captures the raw power and grace of America's national bird.",
    images: [
      "https://images.unsplash.com/photo-1611689342806-0863700ce1e4?w=600&q=80",
      "https://images.unsplash.com/photo-1570612861542-284f4c12e75f?w=600&q=80",
    ],
    featured: false,
  },
  {
    id: 12,
    name: "Maine Coon Portrait",
    category: "Cat",
    price: 109.99,
    rating: 4.7,
    reviews: 98,
    description: "A regal Maine Coon cat sculpture capturing the magnificent size and luscious fur of this gentle giant. Known as the 'dogs of the cat world', this piece beautifully depicts the Maine Coon's distinctive features.",
    images: [
      "https://images.unsplash.com/photo-1615796153287-98eacf0abb13?w=600&q=80",
      "https://images.unsplash.com/photo-1561948955-570b270e7c36?w=600&q=80",
    ],
    featured: false,
  },
];

export const getProductById = (id) => products.find(p => p.id === parseInt(id));
export const getFeaturedProducts = () => products.filter(p => p.featured);
export const getCategories = () => [...new Set(products.map(p => p.category))];
